import Error402 from '../../errors/pages/error402/error402';

export default function CheckoutCancel() {
  return <Error402 />;
}
